module.exports = __webpack_public_path__ + "img/delete-old.7338974c.svg";